import { render, staticRenderFns } from "./TypesProducts.vue?vue&type=template&id=404e730d&"
import script from "./TypesProducts.vue?vue&type=script&lang=js&"
export * from "./TypesProducts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports